import { useValuationData } from '@/pages/CompanyReport/components/Valuation';
import Tooltip from '@/components/Tooltip';
import { Table } from './styled';
import useGlossaryTerms from '@/hooks/useGlossaryTerms';
import { TipContainer, Term } from '../KeyMetricsChart/styled';
import DocumentSchema from '@/components/DocumentSchema';
import type { Table as TableSchema } from 'schema-dts';
import { useValuationTranslation } from '@/pages/CompanyReport/components/Valuation/hooks/useValuationTranslation';

export const KeyMetricsOthers = () => {
  const selected = useValuationData();

  const getTerm = useGlossaryTerms();
  const pegTerm = getTerm('peg ratio');

  const t = useValuationTranslation();

  return (
    <>
      <DocumentSchema<TableSchema>
        item={{
          '@context': 'https://schema.org',
          '@type': 'Table',
          headline: t('keyMetric.chart.others.heading'),
          about: t('keyMetric.chart.others.description', {
            tickerSymbol: selected.tickerSymbol,
          }),
        }}
      />
      <Table data-cy-id="key-metrics-others-table">
        <caption>
          {t('keyMetric.chart.others.description', {
            tickerSymbol: selected.tickerSymbol,
          })}
        </caption>
        <thead>
          <tr>
            <th colSpan={2}>{t('keyMetric.chart.others.heading')}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <Tooltip
                title={
                  <TipContainer>
                    {t('keyMetric.chart.others.revenue')}
                  </TipContainer>
                }
                light
                openDelay={300}
              >
                <Term>{t('keyMetric.chart.others.revenue')}</Term>
              </Tooltip>
            </td>
            <td>{selected.valueRevenueRatio}</td>
          </tr>
          <tr>
            <td>
              <Tooltip
                title={
                  <TipContainer>
                    {t('keyMetric.chart.others.ebitda')}
                  </TipContainer>
                }
                light
                openDelay={300}
              >
                <Term>{t('keyMetric.chart.others.ebitda')}</Term>
              </Tooltip>
            </td>
            <td>{selected.valueEbitdaRatio}</td>
          </tr>
          <tr>
            <td>
              <Tooltip
                title={<TipContainer>{pegTerm}</TipContainer>}
                light
                openDelay={300}
              >
                <Term>{t('keyMetric.chart.others.peg')}</Term>
              </Tooltip>
            </td>
            <td>{selected.PEG}</td>
          </tr>
        </tbody>
      </Table>
    </>
  );
};
